/*
  KÄLLA quiz: PMS or perimenopause. All wording and scoring lives in this
  file. Edit text here; the quiz engine (kalla-quiz.js) reads it.
  Swedish is used on the Swedish site, English everywhere else.
  Points: each answer gives 0 to 3 points toward perimenopause.
  Bands: 0 to 5 PMS, 6 to 11 both, 12 to 19 perimenopause.
*/
window.KALLA_QUIZ = {
  bands: [ { key: "pms", max: 5 }, { key: "mix", max: 11 }, { key: "peri", max: 99 } ],
  maxScore: 19,
  contraceptionAnswer: { question: 1, answer: 3 },

  questions: [
    { id: "timing", type: "list", points: [0, 3, 2],
      sv: {
        title: "Släpper besvären inom ett par dagar efter att mensen har kommit?",
        options: [
          { t: "Ja, jag har minst en bra vecka varje månad" },
          { t: "Nej, de håller i sig större delen av månaden" },
          { t: "Det gjorde de förut, men nu släpper de inte helt längre" }
        ],
        why: "Det här är den tydligaste skiljelinjen. PMS hör till tiden efter ägglossningen och klingar av när blödningen börjar. Besvären i förklimakteriet beror på att östrogennivåerna svänger, och de följer inte cykeln.",
        src: "DSM-5-TR (PMDD); DRSP, Endicott m.fl. 2006"
      },
      en: {
        title: "Do your symptoms clear up within a few days of your period starting?",
        options: [
          { t: "Yes, I get at least one good week every month" },
          { t: "No, they're there most of the month" },
          { t: "They used to, but lately they don't fully lift" }
        ],
        why: "This is the clearest dividing line. PMS belongs to the second half of the cycle and fades once bleeding starts. Perimenopause symptoms come from uneven oestrogen levels and don't follow the cycle.",
        src: "DSM-5-TR criteria for PMDD; DRSP (Endicott et al. 2006)"
      }
    },
    { id: "cycle", type: "list", points: [0, 1, 3, 0],
      sv: {
        title: "Hur regelbunden har din mens varit det senaste året?",
        options: [
          { t: "Regelbunden", h: "Cykeln varierar sällan med mer än ett par dagar" },
          { t: "Lite förändrad", h: "Kortare cykler, eller kraftigare eller svagare blödningar än förut" },
          { t: "Oregelbunden", h: "Cykeln varierar ofta med en vecka eller mer, eller så har det gått 60 dagar eller mer utan mens" },
          { t: "Vet inte", h: "Jag använder hormonellt preventivmedel eller hormonspiral" }
        ],
        why: "Förändringar i cykeln är det säkraste tecknet på förklimakteriet, säkrare än något blodprov. Det är också dem forskarna utgår från när de delar in klimakteriets olika faser.",
        src: "STRAW+10, Harlow m.fl. 2012"
      },
      en: {
        title: "How regular has your cycle been over the past year?",
        options: [
          { t: "Regular", h: "It rarely varies by more than a couple of days" },
          { t: "Slightly changed", h: "Shorter cycles, or heavier or lighter bleeding than before" },
          { t: "Irregular", h: "It often varies by a week or more, or I've gone 60 days or more without a period" },
          { t: "Can't say", h: "I use hormonal contraception or a hormonal coil" }
        ],
        why: "Cycle changes are the most reliable sign of perimenopause, more reliable than any blood test. The system researchers use to stage the transition is built on them.",
        src: "STRAW+10 (Harlow et al. 2012)"
      }
    },
    { id: "flushes", type: "pair", points: [0, 3],
      sv: {
        title: "Får du värmevallningar eller svettas du på natten?",
        options: [
          { t: "Nej", h: "Bara att jag kan bli lite varm före mens" },
          { t: "Ja" }
        ],
        why: "Värmevallningar och nattliga svettningar är de mest kända tecknen på förklimakteriet. Upp till åtta av tio kvinnor får dem någon gång under de här åren, men långt ifrån alla redan i början.",
        src: "The Menopause Society; NICE NG23"
      },
      en: {
        title: "Do you get hot flushes or night sweats?",
        options: [
          { t: "No", h: "At most I feel a bit warmer before my period" },
          { t: "Yes" }
        ],
        why: "Hot flushes and night sweats are the most recognisable sign of perimenopause. Up to eight in ten women get them at some point during the transition, though not everyone does early on.",
        src: "The Menopause Society; NICE NG23"
      }
    },
    { id: "intimate", type: "list", sensitive: true, points: [0, 3, 0],
      sv: {
        title: "Har du på senare tid blivit torr i slidan, fått ont vid sex eller fått besvär med urinblåsan?",
        sub: "Till exempel att du behöver kissa oftare än förut eller lättare får urinvägsinfektioner.",
        sensitiveNote: "Svara bara om det känns okej för dig. Du kan alltid välja ”Vill inte svara”.",
        options: [
          { t: "Nej" },
          { t: "Ja, och det är nytt för mig" },
          { t: "Vill inte svara" }
        ],
        why: "Slidan och urinblåsan har gott om östrogenreceptorer, så när östrogennivån sjunker kan slemhinnorna bli tunnare och torrare. Sådana förändringar hör inte till PMS.",
        src: "The Menopause Society (genitourinary syndrome of menopause)"
      },
      en: {
        title: "Have you noticed new vaginal dryness, pain during sex, or bladder trouble?",
        sub: "Such as needing to go more often, or more UTIs than before.",
        sensitiveNote: "Answer only if you're comfortable. Prefer not to say is always fine.",
        options: [
          { t: "No" },
          { t: "Yes, and it's new for me" },
          { t: "Prefer not to say" }
        ],
        why: "The vagina and bladder are rich in oestrogen receptors, so as oestrogen falls the tissue can become thinner and drier. PMS doesn't cause these changes.",
        src: "The Menopause Society (genitourinary syndrome of menopause)"
      }
    },
    { id: "body", type: "list", points: [0, 2, 1, 0],
      sv: {
        title: "Vad stämmer bäst in på dig?",
        options: [
          { t: "Ömma bröst, svullen mage eller sötsug", h: "Mest veckan före mens" },
          { t: "Värk i lederna, orkeslöshet eller hjärndimma", h: "Större delen av månaden" },
          { t: "Lite av båda" },
          { t: "Inget av det här" }
        ],
        why: "Både PMS och förklimakteriet kan ge ledvärk, trötthet och svårt att koncentrera sig. Det är tidpunkten som skiljer dem åt: besvär som kommer och går före mens tyder på PMS, besvär som sitter i hela månaden tyder på förklimakteriet.",
        src: "DSM-5-TR (PMDD); Greene Climacteric Scale, Greene 1998"
      },
      en: {
        title: "Which of these fits you best?",
        options: [
          { t: "Sore breasts, bloating or cravings", h: "Mainly before my period" },
          { t: "Aching joints, low energy or brain fog", h: "Most of the month" },
          { t: "A mix of both" },
          { t: "None of these" }
        ],
        why: "Joint aches, tiredness and poor concentration can belong to either. Timing separates them: symptoms that come and go before your period point to PMS, symptoms that stay all month point to perimenopause.",
        src: "DSM-5-TR criteria for PMDD; Greene Climacteric Scale (Greene 1998)"
      }
    },
    { id: "mood", type: "list", points: [0, 2, 0],
      sv: {
        title: "Hur förändras ditt humör?",
        options: [
          { t: "Plötsliga humörsvängningar, irritation eller nära till gråt", h: "En eller två veckor före mens, sedan går det över" },
          { t: "Nedstämd, orolig eller avtrubbad", h: "För det mesta" },
          { t: "Humöret är mest som vanligt" }
        ],
        why: "Humörsvängningar vid PMS börjar före mens och släpper strax efter att den har kommit. I förklimakteriet håller nedstämdhet och oro ofta i sig längre, delvis för att man sover sämre.",
        src: "DSM-5-TR (PMDD); SWAN, Bromberger m.fl. 2011"
      },
      en: {
        title: "How would you describe your mood changes?",
        options: [
          { t: "Sudden swings, irritation or tears", h: "In the week or two before my period, then they pass" },
          { t: "A low, anxious or flat feeling", h: "Most of the time" },
          { t: "My mood is mostly fine" }
        ],
        why: "PMS mood swings start before your period and lift soon after it starts. In perimenopause, low mood and anxiety tend to be steadier, partly because sleep gets worse.",
        src: "DSM-5-TR criteria for PMDD; SWAN (Bromberger et al. 2011)"
      }
    },
    { id: "age", type: "scale", points: [0, 1, 2, 3],
      sv: {
        title: "Hur gammal är du?",
        options: [ { t: "Under 35" }, { t: "35 till 39" }, { t: "40 till 44" }, { t: "45 eller äldre" } ],
        why: "Förklimakteriet börjar oftast i 40-årsåldern, och medelåldern för sista mensen är 51 år. PMS kan börja i vilken ålder som helst efter första mensen.",
        src: "NICE NG23 och QS143"
      },
      en: {
        title: "How old are you?",
        options: [ { t: "Under 35" }, { t: "35 to 39" }, { t: "40 to 44" }, { t: "45 or older" } ],
        why: "Perimenopause usually starts in your 40s, and the average age of the last period is 51. PMS can start at any age after your first period.",
        src: "NICE NG23 and QS143"
      }
    }
  ],

  /* What each answer says on the result page: [text, "pms" | "peri"], or null to leave it out */
  signals: {
    sv: {
      timing: [["Besvären släpper när mensen har kommit", "pms"], ["Besvären finns kvar större delen av månaden", "peri"], ["Besvären släpper inte längre helt efter mens", "peri"]],
      cycle: [["Din cykel är regelbunden", "pms"], ["Din cykel har förändrats lite", "peri"], ["Din cykel har blivit oregelbunden", "peri"], null],
      flushes: [null, ["Du får värmevallningar eller svettas på natten", "peri"]],
      intimate: [null, ["Nya besvär i underlivet eller med urinblåsan", "peri"], null],
      body: [["Kroppsliga besvär som kommer veckan före mens", "pms"], ["Värk, orkeslöshet eller hjärndimma större delen av månaden", "peri"], ["Besvär både före mens och resten av månaden", "peri"], null],
      mood: [["Humörsvängningar som följer cykeln", "pms"], ["Nedstämdhet eller oro som sitter i", "peri"], null],
      age: [null, ["Du är i slutet av 30-årsåldern, då cykeln kan börja förändras", "peri"], ["Du är i början av 40-årsåldern, då förklimakteriet ofta sätter in", "peri"], ["Du är 45 eller äldre, den ålder då förklimakteriet är vanligast", "peri"]]
    },
    en: {
      timing: [["Your symptoms ease once your period starts", "pms"], ["Your symptoms stay most of the month", "peri"], ["Your symptoms no longer fully lift after your period", "peri"]],
      cycle: [["Your cycle is regular", "pms"], ["Your cycle has shifted a little", "peri"], ["Your cycle has become irregular", "peri"], null],
      flushes: [null, ["You get hot flushes or night sweats", "peri"]],
      intimate: [null, ["New vaginal or bladder changes", "peri"], null],
      body: [["Physical symptoms that cluster before your period", "pms"], ["Aches, low energy or brain fog most of the month", "peri"], ["Symptoms both before your period and through the month", "peri"], null],
      mood: [["Mood swings that follow your cycle", "pms"], ["Low or anxious mood most of the time", "peri"], null],
      age: [null, ["Late 30s, when cycles can start to shift", "peri"], ["Early 40s, when perimenopause often begins", "peri"], ["45 or over, the most common time for perimenopause", "peri"]]
    }
  },

  ui: {
    sv: {
      introTitle: "PMS eller förklimakteriet?",
      introText: "Förklimakteriet börjar oftast någon gång i 40-årsåldern, flera år innan mensen upphör, och de första tecknen är lätta att ta för PMS. Svara på sju frågor om din cykel och hur du mår, så ser du vilket mönster du stämmer bäst med.",
      start: "Starta testet",
      introMeta: "Tar ungefär två minuter. Ett självtest, ingen diagnos.",
      privacyTitle: "Dina svar stannar hos dig",
      privacy: [
        "Dina svar lämnar aldrig din webbläsare. Vi sparar dem inte, och de försvinner när du stänger sidan.",
        "Lämnar du din e-postadress använder vi den bara till våra vanliga nyhetsbrev. Den sparas aldrig ihop med några hälsouppgifter från testet."
      ],
      privacyLink: "Integritetspolicy",
      back: "Tillbaka",
      why: "Varför vi frågar",
      source: "Underlag",
      gateTitle: "Ditt resultat är klart",
      gateText: "Fyll i din e-postadress så visar vi det på nästa sida. Du får också mejl från KÄLLA om hormoner, din cykel och åren kring klimakteriet.",
      emailLabel: "E-postadress",
      emailError: "Fyll i en giltig e-postadress.",
      gateButton: "Visa mitt resultat",
      gateFine: "Genom att fortsätta anmäler du dig till KÄLLA:s nyhetsbrev, och du kan avregistrera dig när du vill. Vi sparar bara din e-postadress, aldrig dina svar eller ditt resultat.",
      analysing: ["Läser dina svar", "Väger samman dem", "Tar fram ditt resultat"],
      results: {
        pms: { title: "Dina svar pekar mot PMS", lead: "Dina besvär följer cykeln, och inget i dina svar tyder på förklimakteriet.", tip: "Skriv ner hur du mår under cykeln i ett par månader. När du ser mönstret blir det lättare att planera efter de tyngre dagarna." },
        mix: { title: "Dina svar pekar åt båda hållen", lead: "Dina besvär kan ha börjat förändras. I början av förklimakteriet blir PMS som du haft i många år ofta värre eller håller i sig längre.", tip: "Håll koll på hur lång din cykel är och hur du mår under månaden. Förändringarna i 40-årsåldern kommer ofta smygande, och ju tidigare du märker dem, desto lättare är det att förstå vad som händer." },
        peri: { title: "Dina svar pekar mot förklimakteriet", lead: "Du har flera av de typiska tecknen på förklimakteriet, och dina besvär följer inte längre cykeln.", tip: "Förklimakteriet är en naturlig fas som kan pågå i flera år. Hur du sover, rör dig och äter påverkar hur du mår i vardagen." }
      },
      spectrum: ["PMS", "Både och", "Förklimakteriet"],
      fitsPms: "Det som stämmer med PMS",
      fitsPeri: "Det som stämmer med förklimakteriet",
      fitsNone: "Inget i dina svar",
      tipTitle: "Bra att veta",
      contraceptionNote: "Du använder hormonellt preventivmedel, som kan dölja förändringar i din naturliga cykel. Därför väger dina andra svar tyngre i resultatet.",
      productsTitle: "Från KÄLLA",
      products: {
        cycle: "Framtagen för hela cykeln.",
        hm: "Vår bästsäljare, utvecklad för kvinnor i förklimakteriet och klimakteriet."
      },
      readMore: "Läs mer",
      disclaimer: "Det här är ett självtest och ingen medicinsk diagnos. Är du orolig för dina besvär eller vill ha medicinska råd, prata med en läkare eller annan vårdpersonal. Det gäller också om du känner dig nedstämd för det mesta, oavsett vad testet visar.",
      signedUp: "Du är anmäld till KÄLLA:s nyhetsbrev. Dina svar har inte sparats.",
      retake: "Gör testet igen",
      goToSite: "Gå till KÄLLA.com",
      closePage: "Stäng sidan"
    },
    en: {
      introTitle: "Is it PMS or perimenopause?",
      introText: "Perimenopause usually starts in your 40s, several years before your periods stop, and its first signs are easy to mistake for PMS. Seven questions about your cycle and symptoms show which pattern your answers fit.",
      start: "Start",
      introMeta: "Takes about two minutes. A self-assessment, not a diagnosis.",
      privacyTitle: "Your answers stay with you",
      privacy: [
        "Your answers never leave your browser. We don't save them, and they're gone when you close the page.",
        "If you leave your email, we only use it for our general marketing emails. It's never stored with any health data from this quiz."
      ],
      privacyLink: "Privacy policy",
      back: "Back",
      why: "Why we ask",
      source: "Basis",
      gateTitle: "Your result is ready",
      gateText: "Enter your email to see it on the next screen. You'll also get KÄLLA's emails on hormones, your cycle and the years around perimenopause.",
      emailLabel: "Email",
      emailError: "Please enter a valid email address.",
      gateButton: "Show my result",
      gateFine: "By continuing you sign up for emails from KÄLLA, and you can unsubscribe at any time. We only save your email address, never your answers or your result.",
      analysing: ["Reading your answers", "Weighing them up", "Your result"],
      results: {
        pms: { title: "Your answers point to PMS", lead: "Your symptoms follow your cycle, and nothing in your answers points to perimenopause.", tip: "Jot down how you feel through your cycle for a couple of months. Once you can see the pattern, it gets easier to plan around the harder days." },
        mix: { title: "Your answers point both ways", lead: "Your symptoms may be starting to shift. Early in perimenopause, PMS you've had for years often gets stronger or lasts longer.", tip: "Keep an eye on your cycle length and how you feel through the month. Changes in your 40s often come gradually, and the earlier you notice them, the easier it is to understand what's happening." },
        peri: { title: "Your answers point to perimenopause", lead: "Your answers include the typical signs of perimenopause, and your symptoms no longer follow your cycle.", tip: "Perimenopause is a natural phase that can last several years. Sleep, movement and what you eat all play a part in how it feels day to day." }
      },
      spectrum: ["PMS", "Both", "Perimenopause"],
      fitsPms: "What fits PMS",
      fitsPeri: "What fits perimenopause",
      fitsNone: "Nothing in your answers",
      tipTitle: "Good to know",
      contraceptionNote: "You use hormonal contraception, which can hide changes in your natural cycle, so your other answers weigh more in your result.",
      productsTitle: "From KÄLLA",
      products: {
        cycle: "Developed with your whole cycle in mind.",
        hm: "Our bestseller, developed for women in perimenopause and menopause."
      },
      readMore: "Read more",
      disclaimer: "This is a self-assessment and not a medical diagnosis. If you're worried about your symptoms or want medical advice, talk to a doctor or another healthcare professional. The same goes if you feel low most of the time, whatever your result.",
      signedUp: "You're signed up for KÄLLA's emails. Your answers weren't saved.",
      retake: "Take it again",
      goToSite: "Go to KÄLLA.com",
      closePage: "Close page"
    }
  },

  /* Which product cards show for each result (keys match the products in the section settings) */
  resultProducts: { pms: ["cycle"], mix: ["cycle", "hm"], peri: ["hm"] }
};